<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >person</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.myProfile' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->

      <!-- / SEARCH -->



    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      <!-- CONTENT -->
      <div class="content">
        <div class="content-block">
          <cropper [avatar]="avatar" [page]="'profile'"></cropper>
        </div>
        <div class="content-block">
          <div class="logo my-12 m-sm-0 info-label"
            fxLayout="row" fxLayoutAlign="start center">
            <span class="logo-text h1" *fuseIfOnDom >{{'profile.info' | translate}}</span>
          </div>
          <div>
            <form [formGroup]="formGroup">
              <mat-form-field class="width-50">
                <mat-label>{{ 'user.firstName' | translate }}</mat-label>
                <input formControlName="firstName" matInput required>
              </mat-form-field>
              <mat-form-field class="width-50">
                <mat-label>{{ 'user.lastName' | translate }}</mat-label>
                <input formControlName="lastName" matInput required>
              </mat-form-field>
              <mat-form-field class="width-100">
                <mat-label>{{ 'user.email' | translate }}</mat-label>
                <input formControlName="email" matInput>
                @if (formGroup.get('email')?.hasError('checkEmailOnServer')) {
                  <mat-error>
                    {{'checkEmailOnServer' | translate}}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="width-50">
                <mat-label>{{ 'user.eCall' | translate }}</mat-label>
                <input formControlName="eCall" matInput>
              </mat-form-field>
              <mat-form-field class="width-50">
                <mat-label>{{ 'user.phone' | translate }}</mat-label>
                <input formControlName="phone" matInput appPhoneMask>
              </mat-form-field>
              <mat-form-field appearance="fill" class="width-50">
                <mat-label>{{'user.lang' | translate}}</mat-label>
                <mat-select formControlName="lang" required>
                  @for (lang of languages; track lang) {
                    <mat-option [value]="lang.value">
                      {{lang?.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </form>
          </div>
          @if (roleId && +roleId === 4) {
            <div>
              <form [formGroup]="notificationForm" class="not-form width-100">
                <mat-checkbox formControlName="newRegistration">{{'new_reg_notif' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="newBooking">{{'new_book_notif' | translate}}</mat-checkbox>
              </form>
            </div>
          }
          <div>
            <button mat-raised-button class="submit-button float-right" color="accent"
              [disabled]="!formWasChanged || !formGroup.valid"
              (click)="saveProfile()">
              {{'profile.save' | translate}}
            </button>
          </div>
          <div class="logo my-12 m-sm-0 info-label"
            fxLayout="row" fxLayoutAlign="start center">
            <span class="logo-text h1" *fuseIfOnDom >{{'profile.change_pass' | translate}}</span>
          </div>
          <div>
            <form [formGroup]="passwordForm" class="password-form width-100">
              <mat-form-field class="width-100">
                <mat-label>{{'Old_password' | translate}}</mat-label>
                <input matInput formControlName="oldPass">
                @if (passwordFormError.oldPassError) {
                  <mat-error>
                    {{'profile.old_password_error' | translate}}
                  </mat-error>
                }
              </mat-form-field>

              <mat-form-field class="width-100">
                <mat-label>{{'New_password' | translate}}</mat-label>
                <input matInput formControlName="newPass">
                @if (passwordFormError.newPassError) {
                  <mat-error>
                    {{'profile.password_error' | translate}}
                  </mat-error>
                }
              </mat-form-field>

              <mat-form-field class="width-100">
                <mat-label>{{'Confirm_password' | translate}}</mat-label>
                <input matInput formControlName="confirmPass">
                @if (passwordFormError.confirmPassError) {
                  <mat-error>
                    {{'profile.confirm_password_error' | translate}}
                  </mat-error>
                }
              </mat-form-field>

              <button mat-raised-button class="submit-button float-right" color="accent"
                      [disabled]="passwordFormError.oldPassError || passwordFormError.newPassError ||
                                  passwordFormError.confirmPassError || passwordForm.get('newPass').value === '' ||
                                   passwordForm.get('oldPass').value === '' || passwordForm.get('confirmPass').value === ''"
                (click)="changePassword()">
                {{'profile.change_pass' | translate}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
